import React from "react";
import "./discuss-notice.scss";
import { UserOutlined, RightOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { NavLink } from "react-router-dom";

function DiscussNotice({ discussItem }) {
  return (
    <NavLink
      to={`/discuss/detail/${discussItem.id}`}
      className="discuss-notice"
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          style={{ flexShrink: 0, width: 39, height: 42 }}
          src="https://cdn.datongbei.com/icdesign-17490288279413045ef81h5a3a.png?imageView2/0/format/jpg/q/90|imageslim"
        />
        <div className="discuss-notice-title">{discussItem?.title}</div>
        <div className="discuss-notice-right-icon" style={{ flexShrink: 0 }}>
          <RightOutlined />
          <RightOutlined />
        </div>
      </div>
      <div className="discuss-notice-tags">
        <div className="discuss-notice-tag">公告</div>
        <div className="discuss-select-tag">置顶</div>
      </div>
    </NavLink>
  );
}

export default DiscussNotice;
